import $api from '../../utils/api.js'


const state = () => ({
    formprofile:{
        id:'',
        email:'',
        name:'',
        photo:'',
        brand:'',
        code:'',
        sosmed_link:'',
        logo:'',
        password:'',
        confirmation:'',
        challenge:{},
        achievement:{},
    },
    slots:0,
    errors:[],
})

const mutations = {
    ASSIGN_DATA_PROFILE(state, payload) {
        state.formprofile = {
            id:payload.id,
            parent:payload.parent,
            email:payload.email,
            name:payload.name,
            photo:payload.photo,
            code:payload.code,
            brand:payload.brand,
            sosmed_link:payload.sosmed_link,
            logo:payload.logo,
            password:'',
            confirmation:'',
            challenge:payload.challenge,
            achievement:payload.achievement,
        }
        state.slots = payload.slots
    },
    CLEAR_FORM_PROFILE(state) {
        state.formprofile = {
            id:'',
            email:'',
            name:'',
            photo:'',
            brand:'',
            code:'',
            sosmed_link:'',
            logo:'',
            password:'',
            confirmation:'',
            challenge:{},
            achievement:{},
        },
        state.errors = []
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getProfile({ commit }) {
        return new Promise((resolve) => {
            $api.get(`profile`)
            .then((response) => {
                commit('ASSIGN_DATA_PROFILE', response.data)
                resolve(response.data)
            })
        })
    },
    updateProfile({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`profile`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    confirmChallenge({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.get(`confirm-challenge/${payload}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    confirmAchievement({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.get(`confirm-achievement/${payload}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
